import DropdownMenu from '../DropdownMenu/DropdownMenu';
import SpirisIcon from '../Icon/SpirisIcon';

export interface RowAction {
    id: string;
    label: string;
    icon?: string;
    destructive?: boolean;
    onClick: () => void;
}

interface RowActionsMenuProps {
    label: string;
    actions: RowAction[];
}

// the kebab menu for table rows and cards: DropdownMenu with the icon-button trigger, so every row menu shares one keyboard model
const RowActionsMenu = ({ label, actions }: RowActionsMenuProps) => (
    <DropdownMenu
        label={label}
        triggerClassName="btn btn-icon btn-sm"
        trigger={<SpirisIcon name="vertical-menu" size="sm" />}
        items={actions.map((action) => ({ key: action.id, label: action.label, icon: action.icon, destructive: action.destructive, onClick: action.onClick }))}
    />
);

export default RowActionsMenu;
